@if (!gamesSearch?.showFiltersBar) {
  @if (gamesSearch?.searchStr && gamesSearch?.showPopup) {
    @if (gamesSearch?.foundedGames$ | async; as games) {
      @if (games?.gameList?.length) {
        <div class="bar__title">{{'link.games' | translate}}</div>
        <div class="bar__games">
          <div class="game-grid">
            @for (game of games?.gameList; track game?.id) {
              <div class="game-grid__item">
                <app-game-preview [game]="game"></app-game-preview>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="bar__not-found">{{'t.games-not-found' | translate}}</div>
        <div class="bar__games">
          <app-game-list [config]="hotGameListConfig"></app-game-list>
        </div>
      }
    } @else {
      <app-preloader></app-preloader>
    }
  }
  @if (!gamesSearch.searchStr && gamesSearch.showPopup) {
    <div class="bar__games">
      <app-game-list [config]="hotGameListConfig"></app-game-list>
    </div>
  }
}
